var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carbonfootprint-wapper"},[_c('e-title',_vm._g(_vm._b({attrs:{"title":_vm.title}},'e-title',_vm.$attrs,false),_vm.$listeners),[_vm._t("title"),_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._t("default")],2)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }